module.exports = __webpack_public_path__ + "media/tweet-to-video-blue.d07391cc.mp4";